import { DownloadActions } from '@app/components/checkout/DownloadActions';
import { CopyToNewSelectionModal } from '@app/components/orders/CopyToNewSelectionModal';
import { Button } from '@app/components/various/Button';
import { Copy } from '@app/components/various/Icons';
import { BREAKPOINTS } from '@app/constants/breakpoints';
import { getIsUserKnown, getOrderDetails } from '@app/ducks';
import { useAmplitude, useIsScreenSize } from '@app/utils/hooks';
import { useModalToggle } from '@app/utils/hooks/useModalToggle';
import { User } from '@typings';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

interface Props {
  user: User | Empty.Object;
  isDisabled: boolean;
}

export const CheckoutSummaryActions = ({ user, isDisabled }: Props) => {
  const { order, buyer } = useSelector(getOrderDetails);
  const { t } = useTranslation(['selections']);
  const { showModal, isOpen, hideModal } = useModalToggle();
  const { trackEvent } = useAmplitude();
  const { pathname } = useLocation();

  const isMobile = useIsScreenSize(BREAKPOINTS.MD);

  const handleCopySelectionSubmit = () => {
    trackEvent({
      name: 'selectionAction.button.copySelection.click',
      properties: { path: pathname.includes('success') ? 'checkoutSuccess' : 'checkout' },
    });
  };

  return (
    <>
      <div className="flex flex-wrap gap-x-4 gap-y-3">
        {getIsUserKnown(user) && (
          <Button
            color="secondary"
            variant="bordered"
            size="large"
            icon={Copy}
            aria-label={t('selections:copy_to_new_selection')}
            disabled={isDisabled}
            onClick={showModal}
          >
            {isMobile ? undefined : t('selections:copy_to_new_selection')}
          </Button>
        )}
        <DownloadActions order={order} isDisabled={isDisabled} />
      </div>
      <CopyToNewSelectionModal
        isOpen={isOpen}
        onClose={hideModal}
        orderId={order.order}
        orderNumber={order.orderNumber}
        defaultBuyer={buyer.buyer}
        onSubmit={handleCopySelectionSubmit}
      />
    </>
  );
};
